var u = (p, m, a) => new Promise((n, t) => {
  var r = (e) => {
    try {
      s(a.next(e));
    } catch (l) {
      t(l);
    }
  }, d = (e) => {
    try {
      s(a.throw(e));
    } catch (l) {
      t(l);
    }
  }, s = (e) => e.done ? n(e.value) : Promise.resolve(e.value).then(r, d);
  s((a = a.apply(p, m)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import A from "./indexTableItem.vue.js";
import { vCopyVueucStylesToShadowDom as y } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { vShadowPropertyPolyfill as h } from "../../utils/vShadowPropertyPolyfill.js";
import { defineComponent as C, useTemplateRef as b, withDirectives as w, openBlock as _, createBlock as S, withCtx as c, createVNode as f } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as x } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import B from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import I from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import T from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const q = /* @__PURE__ */ C({
  __name: "indexTable.ce",
  props: {
    businessId: { default: "", type: null },
    isShowAddApprovalButton: { type: Boolean, default: !1 },
    isAll: { type: Boolean, default: !1 },
    status: { default: "", type: null }
  },
  emits: ["submit", "cancal", "addApproval"],
  setup(p, { expose: m, emit: a }) {
    const n = b("indexTableItemRefs"), t = p, r = x(), d = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, s = a, e = (i) => {
      s("submit", i);
    }, l = () => {
      s("cancal");
    }, v = () => {
      s("addApproval");
    };
    return m({ init: () => u(this, null, function* () {
      var i;
      yield (i = n.value) == null ? void 0 : i.init();
    }) }), (i, P) => w((_(), S(o(R), {
      locale: o(B),
      "date-locale": o(I),
      "theme-overrides": d,
      "style-mount-target": o(r)
    }, {
      default: c(() => [
        f(o(T), { to: o(r) }, {
          default: c(() => [
            f(A, {
              ref_key: "indexTableItemRefs",
              ref: n,
              onSubmit: e,
              onCancal: l,
              onAddApproval: v,
              businessId: t.businessId,
              isAll: t.isAll,
              isShowAddApprovalButton: t.isShowAddApprovalButton,
              status: t.status
            }, null, 8, ["businessId", "isAll", "isShowAddApprovalButton", "status"])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [o(y), o(r)],
      [o(h), o(r)]
    ]);
  }
});
export {
  q as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/approval-table/indexTable.ce.vue2.js
// module id = 1217
// module chunks = 67